var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "slideContainer" }, [
    _vm.theme == "red"
      ? _c(
          "div",
          { staticClass: "operating" },
          [
            _c("Title", {
              attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
            }),
            _c("div", { staticClass: "cards" }, [
              _vm.chzzl
                ? _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "head" }, [
                      _c("div", { staticClass: "rectangle" }, [
                        _vm.language === "zh"
                          ? _c("div", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(_vm.jsonData.year) +
                                  _vm._s(_vm.periodName)
                              ),
                            ])
                          : _vm.language === "en"
                          ? _c("div", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(_vm.jsonData.year) +
                                  _vm._s(_vm.periodNameEng)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "unequal-triangle" }),
                      _vm._m(0),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("存货周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Inventory Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText1", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.chzzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.chzzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.yszkzzl
                ? _c(
                    "div",
                    {
                      staticClass: "card",
                      staticStyle: { border: "1px solid #2d3e50" },
                    },
                    [
                      _c("div", { staticClass: "head" }, [
                        _c(
                          "div",
                          {
                            staticClass: "rectangle",
                            staticStyle: {
                              "background-color": "#2d3e50",
                              "border-color": "#2d3e50",
                            },
                          },
                          [
                            _vm.language === "zh"
                              ? _c("div", { staticClass: "text" }, [
                                  _vm._v(
                                    _vm._s(_vm.jsonData.year) +
                                      _vm._s(_vm.periodName)
                                  ),
                                ])
                              : _vm.language === "en"
                              ? _c("div", { staticClass: "text" }, [
                                  _vm._v(
                                    _vm._s(_vm.jsonData.year) +
                                      _vm._s(_vm.periodNameEng)
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c("div", {
                          staticClass: "unequal-triangle",
                          staticStyle: { "border-top": "26px solid #2d3e50" },
                        }),
                        _vm._m(1),
                      ]),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "name" }, [
                            _vm._v("应收账款周转率"),
                          ])
                        : _vm.language === "en"
                        ? _c(
                            "div",
                            {
                              staticClass: "name",
                              staticStyle: {
                                "margin-top": "22px",
                                height: "40px",
                              },
                            },
                            [_vm._v("Accounts Receivable Turnover")]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          class: [_vm.language === "zh" ? "zh_num" : "en_num"],
                        },
                        [
                          _c(
                            "span",
                            { ref: "fadeInText2", staticClass: "fade-in-text" },
                            [
                              _vm._v(_vm._s(_vm.yszkzzl)),
                              _c("span", { staticClass: "unit" }, [
                                _vm._v(_vm._s(_vm.yszkzzlUnit)),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.zzczzl
                ? _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "head" }, [
                      _c("div", { staticClass: "rectangle" }, [
                        _vm.language === "zh"
                          ? _c("div", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(_vm.jsonData.year) +
                                  _vm._s(_vm.periodName)
                              ),
                            ])
                          : _vm.language === "en"
                          ? _c("div", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(_vm.jsonData.year) +
                                  _vm._s(_vm.periodNameEng)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "unequal-triangle" }),
                      _vm._m(2),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("总资产周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Total Asset Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText3", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.zzczzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zzczzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        )
      : _vm.theme == "purple"
      ? _c(
          "div",
          { staticClass: "operating" },
          [
            _c("Title", {
              attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
            }),
            _c("div", { staticClass: "cards" }, [
              _vm.chzzl
                ? _c("div", { staticClass: "card card1" }, [
                    _c("div", { staticClass: "head" }, [
                      _vm._m(3),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) +
                                _vm._s(_vm.periodNameEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("存货周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Inventory Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText1", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.chzzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.chzzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.yszkzzl
                ? _c("div", { staticClass: "card card2" }, [
                    _c("div", { staticClass: "head" }, [
                      _vm._m(4),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) +
                                _vm._s(_vm.periodNameEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("应收账款周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Accounts Receivable Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText2", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.yszkzzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yszkzzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.zzczzl
                ? _c("div", { staticClass: "card card3" }, [
                    _c("div", { staticClass: "head" }, [
                      _vm._m(5),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) +
                                _vm._s(_vm.periodNameEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("总资产周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Total Asset Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText3", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.zzczzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zzczzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "operating" },
          [
            _c("Title", {
              attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
            }),
            _c("div", { staticClass: "cards" }, [
              _vm.chzzl
                ? _c("div", { staticClass: "card card1" }, [
                    _c("div", { staticClass: "head" }, [
                      _vm._m(6),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) +
                                _vm._s(_vm.periodNameEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("存货周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Inventory Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText1", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.chzzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.chzzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.yszkzzl
                ? _c("div", { staticClass: "card card2" }, [
                    _c("div", { staticClass: "head" }, [
                      _vm._m(7),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "text yszkzzlText" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("div", { staticClass: "text yszkzzlTextEng" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) +
                                _vm._s(_vm.periodNameEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name yszkzzl-name" }, [
                          _vm._v("应收账款周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Accounts Receivable Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText2", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.yszkzzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yszkzzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.zzczzl
                ? _c("div", { staticClass: "card card3" }, [
                    _c("div", { staticClass: "head" }, [
                      _vm._m(8),
                      _vm.language === "zh"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                            ),
                          ])
                        : _vm.language === "en"
                        ? _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.jsonData.year) +
                                _vm._s(_vm.periodNameEng)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("总资产周转率"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "name" }, [
                          _vm._v("Total Asset Turnover"),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { class: [_vm.language === "zh" ? "zh_num" : "en_num"] },
                      [
                        _c(
                          "span",
                          { ref: "fadeInText3", staticClass: "fade-in-text" },
                          [
                            _vm._v(_vm._s(_vm.zzczzl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zzczzlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/chzhl.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/yszk.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/zzc.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/chzhl.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/yszk.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/zzc.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/chzhl.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon yszkzzlIcon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/yszk.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../assets/image/red/zzc.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }